import CompetitionRegistration from "./pages/CompetitionRegistration";
import { Routes, Route } from "react-router-dom";
import TourForm from "./pages/TourForm";
import Confirmation from "./pages/Confirmation";
import HomiePagie from "./Homapag/HomiePagie";
import ContractSigning from "./pages/ContractSigning";
import ContractInvites from "./pages/ContractInvites";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomiePagie />} />
      <Route path="/competencia" element={<CompetitionRegistration />} />
      <Route path="/tour-form" element={<TourForm />} />
      <Route path="/confirmation" element={<Confirmation />} />
      <Route path="/contratos" element={<ContractSigning />} />
      <Route path="/contratos/admin" element={<ContractInvites />} />
    </Routes>
  );
}
